import { HomepageStoryblokConfig } from "../types";

export const homeStoryblokConfigMock: HomepageStoryblokConfig = {
  templates: ["expert", "default", "novice"],
  expert: {
    labelName: "Expert",
    description: "",
    top: [
      {
        componentName: "QuickLinks",
        title: ""
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races"
      }
    ],
    side: [
      {
        componentName: "PromosWidget",
        title: "Promotions Calendar"
      },
      {
        componentName: "TopPools",
        title: "Top Pools"
      }
    ],
    main: [
      {
        componentName: "TalentPicks",
        title: "Talent Picks"
      },
      {
        componentName: "TopTracks",
        title: "Top Tracks"
      }
    ],
    bottom: [
      {
        title: "Horse Racing Betting",
        description: "",
        previewImage: undefined,
        componentName: "SEOFooter",
        text: '<p>\n    <span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span>Welcome to <a href="/">FanDuel Racing</a>! We offer an unparalleled experience on a trustworthy platform. Our interface is easy to use. Round-the-clock races put you in the heart of the action.\n</p>\n<p>\n    Get access to:\n    </p><ul>  \n        <li>Major events</li>\n        <li>Easy deposits</li>\n        <li><a href="/promos">Exclusive promos</a></li>\n        <li>Swift payouts</li>\n    </ul>\n<p></p>\n<p>\n    Knowledge is everything! Explore:\n    </p><ul>\n        <li><a href="https://support.fanduelracing.com/s/" target="_blank">Our support site</a> for any questions</li>\n    </ul>\n<p></p>\n<p>\n    Stay engaged with:\n    </p><ul>\n        <li><a href="https://www.fanduel.com/watch" target="_blank">Live FanDuel TV coverage</a> of 300+ global racetracks</li>\n        <li><a href="/handicapping/talent-picks">Picks and previews</a> from your favorite FanDuel TV talent experts</li>\n        <li><a href="https://www.fanduel.com/research/horse-racing" target="_blank">Exclusive horse racing news</a></li>\n    </ul>\n<p></p>\n<p>\n    Get ready to bet on the Triple Crown: <a href="https://www.fanduel.com/kentucky-derby-betting" target="_blank">Kentucky Derby</a>, <a href="https://www.fanduel.com/preakness-stakes-betting" target="_blank">Preakness Stakes</a>, \n<a href="https://www.fanduel.com/belmont-stakes-betting" target="_blank">Belmont Stakes</a>, \n<a href="https://www.fanduel.com/breeders-cup-betting" target="_blank">Breeders Cup</a>.\n</p>\n<p>\n    Want to play FanDuel Racing alone? Or through <a href="https://sportsbook.fanduel.com/" target="_blank">FanDuel Sportsbook</a>?  No problem. In both apps, we blend tradition with cutting-edge technology. You’re ready for the races!\n</p>'
      }
    ]
  },
  default: {
    labelName: "Default",
    description: "",

    top: [
      {
        componentName: "QuickLinks",
        title: "QuickLinks"
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races"
      }
    ],
    side: [
      {
        componentName: "TopPools",
        title: "Top Pools"
      },
      {
        componentName: "PromosWidget",
        title: "Promotions Calendar"
      }
    ],
    main: [
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks"
      },
      {
        componentName: "TalentPicks",
        title: "Talent Picks"
      }
    ],
    bottom: [
      {
        title: "Horse Racing Betting",
        componentName: "SEOFooter",
        description: "",
        previewImage: undefined,
        text: '<p>\n    <span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span>Welcome to <a href="/">FanDuel Racing</a>! We offer an unparalleled experience on a trustworthy platform. Our interface is easy to use. Round-the-clock races put you in the heart of the action.\n</p>\n<p>\n    Get access to:\n    </p><ul>  \n        <li>Major events</li>\n        <li>Easy deposits</li>\n        <li><a href="/promos">Exclusive promos</a></li>\n        <li>Swift payouts</li>\n    </ul>\n<p></p>\n<p>\n    Knowledge is everything! Explore:\n    </p><ul>\n        <li><a href="https://support.fanduelracing.com/s/" target="_blank">Our support site</a> for any questions</li>\n    </ul>\n<p></p>\n<p>\n    Stay engaged with:\n    </p><ul>\n        <li><a href="https://www.fanduel.com/watch" target="_blank">Live FanDuel TV coverage</a> of 300+ global racetracks</li>\n        <li><a href="/handicapping/talent-picks">Picks and previews</a> from your favorite FanDuel TV talent experts</li>\n        <li><a href="https://www.fanduel.com/research/horse-racing" target="_blank">Exclusive horse racing news</a></li>\n    </ul>\n<p></p>\n<p>\n    Get ready to bet on the Triple Crown: <a href="https://www.fanduel.com/kentucky-derby-betting" target="_blank">Kentucky Derby</a>, <a href="https://www.fanduel.com/preakness-stakes-betting" target="_blank">Preakness Stakes</a>, \n<a href="https://www.fanduel.com/belmont-stakes-betting" target="_blank">Belmont Stakes</a>, \n<a href="https://www.fanduel.com/breeders-cup-betting" target="_blank">Breeders Cup</a>.\n</p>\n<p>\n    Want to play FanDuel Racing alone? Or through <a href="https://sportsbook.fanduel.com/" target="_blank">FanDuel Sportsbook</a>?  No problem. In both apps, we blend tradition with cutting-edge technology. You’re ready for the races!\n</p>'
      }
    ]
  },
  novice: {
    labelName: "Novice",
    description: "",
    top: [
      {
        componentName: "QuickLinks",
        description:
          "Promotions carousel. Take advantage of our best deals and enjoy ",
        previewImage: undefined,
        title: ""
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races"
      }
    ],
    side: [
      {
        componentName: "PromosWidget",
        title: "Promotions Calendar"
      },
      {
        componentName: "TopPools",
        title: "Top Pools"
      }
    ],
    main: [
      {
        componentName: "TalentPicks",
        title: "Talent Picks"
      },
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks"
      }
    ],
    bottom: [
      {
        title: "Horse Racing Betting",
        componentName: "SEOFooter",
        description: "",
        previewImage: undefined,
        text: '<p>\n    <span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span>Welcome to <a href="/">FanDuel Racing</a>! We offer an unparalleled experience on a trustworthy platform. Our interface is easy to use. Round-the-clock races put you in the heart of the action.\n</p>\n<p>\n    Get access to:\n    </p><ul>  \n        <li>Major events</li>\n        <li>Easy deposits</li>\n        <li><a href="/promos">Exclusive promos</a></li>\n        <li>Swift payouts</li>\n    </ul>\n<p></p>\n<p>\n    Knowledge is everything! Explore:\n    </p><ul>\n        <li><a href="https://support.fanduelracing.com/s/" target="_blank">Our support site</a> for any questions</li>\n    </ul>\n<p></p>\n<p>\n    Stay engaged with:\n    </p><ul>\n        <li><a href="https://www.fanduel.com/watch" target="_blank">Live FanDuel TV coverage</a> of 300+ global racetracks</li>\n        <li><a href="/handicapping/talent-picks">Picks and previews</a> from your favorite FanDuel TV talent experts</li>\n        <li><a href="https://www.fanduel.com/research/horse-racing" target="_blank">Exclusive horse racing news</a></li>\n    </ul>\n<p></p>\n<p>\n    Get ready to bet on the Triple Crown: <a href="https://www.fanduel.com/kentucky-derby-betting" target="_blank">Kentucky Derby</a>, <a href="https://www.fanduel.com/preakness-stakes-betting" target="_blank">Preakness Stakes</a>, \n<a href="https://www.fanduel.com/belmont-stakes-betting" target="_blank">Belmont Stakes</a>, \n<a href="https://www.fanduel.com/breeders-cup-betting" target="_blank">Breeders Cup</a>.\n</p>\n<p>\n    Want to play FanDuel Racing alone? Or through <a href="https://sportsbook.fanduel.com/" target="_blank">FanDuel Sportsbook</a>?  No problem. In both apps, we blend tradition with cutting-edge technology. You’re ready for the races!\n</p>'
      }
    ]
  }
};

export const homeStoryblokConfigMockWithFallback = {
  templates: ["default", "novice", "expert"],
  default: {
    labelName: "Version 1",
    description: "Default Profile",
    top: [
      {
        componentName: "QuickLinks",
        title: "QuickLinks",
        description:
          "Promotions carousel. Take advantage of our best deals and enjoy ",
        previewImage: undefined
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races",
        description: "FD recommended races so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/843x422/e2159256b0/topraces.png",
          focus: "",
          id: 20107572,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    side: [
      {
        componentName: "TopPools",
        title: "Top Pools",
        description: "Best Races! Bets Pools. List of highest pools of the day",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/364x386/b834b23256/toppools.png",
          focus: "",
          id: 20107570,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "PreviousWinners",
        title: "Previous Winners",
        description:
          "List of your horses that have won in any of your previous bets",
        previewImage: {
          alt: null,
          copyright: null,
          fieldtype: "asset",
          filename: null,
          focus: null,
          id: null,
          is_external_url: false,
          meta_data: {},
          name: "",
          title: null
        }
      }
    ],
    main: [
      {
        componentName: "TopTracks",
        title: "Top Tracks",
        description:
          "FD recommended Tracks so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/716x427/f357deb93d/toptracks.png",
          focus: "",
          id: 20107574,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TalentPicks",
        title: "Talent Picks",
        description:
          "It's not every day that TV Talents to give you some free tips!! Take advantage of it!",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/421x352/2774e6d638/talentpicks.png",
          focus: "",
          id: 20107577,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "FeaturedSection",
        title: "Tutorials",
        description: "Learn the basic and advanced betting techniques",
        previewImage: undefined
      },
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks",
        description: "Watch and Learn great tips and insights with experts",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/415x352/108258af6f/tips-picks.png",
          focus: "",
          id: 20107576,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    bottom: [
      {
        componentName: "SEOFooter",
        description: "",
        previewImage: undefined,
        title: "Horse Racing Betting",
        text: '<p>\n    <span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span>Welcome to <a href="/">FanDuel Racing</a>! We offer an unparalleled experience on a trustworthy platform. Our interface is easy to use. Round-the-clock races put you in the heart of the action.\n</p>\n<p>\n    Get access to:\n    </p><ul>  \n        <li>Major events</li>\n        <li>Easy deposits</li>\n        <li><a href="/promos">Exclusive promos</a></li>\n        <li>Swift payouts</li>\n    </ul>\n<p></p>\n<p>\n    Knowledge is everything! Explore:\n    </p><ul>\n        <li><a href="https://support.fanduelracing.com/s/" target="_blank">Our support site</a> for any questions</li>\n    </ul>\n<p></p>\n<p>\n    Stay engaged with:\n    </p><ul>\n        <li><a href="https://www.fanduel.com/watch" target="_blank">Live FanDuel TV coverage</a> of 300+ global racetracks</li>\n        <li><a href="/handicapping/talent-picks">Picks and previews</a> from your favorite FanDuel TV talent experts</li>\n        <li><a href="https://www.fanduel.com/research/horse-racing" target="_blank">Exclusive horse racing news</a></li>\n    </ul>\n<p></p>\n<p>\n    Get ready to bet on the Triple Crown: <a href="https://www.fanduel.com/kentucky-derby-betting" target="_blank">Kentucky Derby</a>, <a href="https://www.fanduel.com/preakness-stakes-betting" target="_blank">Preakness Stakes</a>, \n<a href="https://www.fanduel.com/belmont-stakes-betting" target="_blank">Belmont Stakes</a>, \n<a href="https://www.fanduel.com/breeders-cup-betting" target="_blank">Breeders Cup</a>.\n</p>\n<p>\n    Want to play FanDuel Racing alone? Or through <a href="https://sportsbook.fanduel.com/" target="_blank">FanDuel Sportsbook</a>?  No problem. In both apps, we blend tradition with cutting-edge technology. You’re ready for the races!\n</p>'
      }
    ]
  },
  novice: {
    labelName: "Version 2",
    description: "Beginners",
    top: [
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races",
        description: "FD recommended races so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/843x422/e2159256b0/topraces.png",
          focus: "",
          id: 20107572,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "QuickLinks",
        title: "QuickLinks",
        description:
          "Promotions carousel. Take advantage of our best deals and enjoy ",
        previewImage: undefined
      }
    ],
    side: [
      {
        componentName: "PreviousWinners",
        title: "Previous Winners",
        description:
          "List of your horses that have won in any of your previous bets",
        previewImage: {
          alt: null,
          copyright: null,
          fieldtype: "asset",
          filename: null,
          focus: null,
          id: null,
          is_external_url: false,
          meta_data: {},
          name: "",
          title: null
        }
      },
      {
        componentName: "FeaturedSection",
        title: "Tutorials",
        description: "Learn the basic and advanced betting techniques",
        previewImage: undefined
      },
      {
        componentName: "TopPools",
        title: "Top Pools",
        description: "Best Races! Bets Pools. List of highest pools of the day",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/364x386/b834b23256/toppools.png",
          focus: "",
          id: 20107570,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    main: [
      {
        componentName: "TalentPicks",
        title: "Talent Picks",
        description:
          "It's not every day that TV Talents to give you some free tips!! Take advantage of it!",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/421x352/2774e6d638/talentpicks.png",
          focus: "",
          id: 20107577,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks",
        description: "Watch and Learn great tips and insights with experts",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/415x352/108258af6f/tips-picks.png",
          focus: "",
          id: 20107576,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopTracks",
        title: "Top Tracks",
        description:
          "FD recommended Tracks so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/716x427/f357deb93d/toptracks.png",
          focus: "",
          id: 20107574,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    bottom: [
      {
        componentName: "SEOFooter",
        description: "",
        previewImage: undefined,
        title: "Horse Racing Betting",
        text: '<p>\n    <span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span>Welcome to <a href="/">FanDuel Racing</a>! We offer an unparalleled experience on a trustworthy platform. Our interface is easy to use. Round-the-clock races put you in the heart of the action.\n</p>\n<p>\n    Get access to:\n    </p><ul>  \n        <li>Major events</li>\n        <li>Easy deposits</li>\n        <li><a href="/promos">Exclusive promos</a></li>\n        <li>Swift payouts</li>\n    </ul>\n<p></p>\n<p>\n    Knowledge is everything! Explore:\n    </p><ul>\n        <li><a href="https://support.fanduelracing.com/s/" target="_blank">Our support site</a> for any questions</li>\n    </ul>\n<p></p>\n<p>\n    Stay engaged with:\n    </p><ul>\n        <li><a href="https://www.fanduel.com/watch" target="_blank">Live FanDuel TV coverage</a> of 300+ global racetracks</li>\n        <li><a href="/handicapping/talent-picks">Picks and previews</a> from your favorite FanDuel TV talent experts</li>\n        <li><a href="https://www.fanduel.com/research/horse-racing" target="_blank">Exclusive horse racing news</a></li>\n    </ul>\n<p></p>\n<p>\n    Get ready to bet on the Triple Crown: <a href="https://www.fanduel.com/kentucky-derby-betting" target="_blank">Kentucky Derby</a>, <a href="https://www.fanduel.com/preakness-stakes-betting" target="_blank">Preakness Stakes</a>, \n<a href="https://www.fanduel.com/belmont-stakes-betting" target="_blank">Belmont Stakes</a>, \n<a href="https://www.fanduel.com/breeders-cup-betting" target="_blank">Breeders Cup</a>.\n</p>\n<p>\n    Want to play FanDuel Racing alone? Or through <a href="https://sportsbook.fanduel.com/" target="_blank">FanDuel Sportsbook</a>?  No problem. In both apps, we blend tradition with cutting-edge technology. You’re ready for the races!\n</p>'
      }
    ]
  },
  expert: {
    labelName: "Version 3",
    description: "Expertise",
    top: [
      {
        componentName: "PreviousWinners",
        title: "Previous Winners",
        description:
          "List of your horses that have won in any of your previous bets",
        previewImage: {
          alt: null,
          copyright: null,
          fieldtype: "asset",
          filename: null,
          focus: null,
          id: null,
          is_external_url: false,
          meta_data: {},
          name: "",
          title: null
        }
      },
      {
        componentName: "QuickLinks",
        title: "QuickLinks",
        description:
          "Promotions carousel. Take advantage of our best deals and enjoy ",
        previewImage: undefined
      },
      {
        componentName: "TopPools",
        title: "Top Pools",
        description: "Best Races! Bets Pools. List of highest pools of the day",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/364x386/b834b23256/toppools.png",
          focus: "",
          id: 20107570,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "FeaturedSection",
        title: "Tutorials",
        description: "Learn the basic and advanced betting techniques",
        previewImage: undefined
      },
      {
        componentName: "TalentPicks",
        title: "Talent Picks",
        description:
          "It's not every day that TV Talents to give you some free tips!! Take advantage of it!",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/421x352/2774e6d638/talentpicks.png",
          focus: "",
          id: 20107577,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks",
        description: "Watch and Learn great tips and insights with experts",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/415x352/108258af6f/tips-picks.png",
          focus: "",
          id: 20107576,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races",
        description: "FD recommended races so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/843x422/e2159256b0/topraces.png",
          focus: "",
          id: 20107572,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopTracks",
        title: "Top Tracks",
        description:
          "FD recommended Tracks so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/716x427/f357deb93d/toptracks.png",
          focus: "",
          id: 20107574,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    side: [
      {
        componentName: "TopPools",
        title: "Top Pools",
        description: "Best Races! Bets Pools. List of highest pools of the day",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/364x386/b834b23256/toppools.png",
          focus: "",
          id: 20107570,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "FeaturedSection",
        title: "Tutorials",
        description: "Learn the basic and advanced betting techniques",
        previewImage: undefined
      },
      {
        componentName: "PreviousWinners",
        title: "Previous Winners",
        description:
          "List of your horses that have won in any of your previous bets",
        previewImage: {
          alt: null,
          copyright: null,
          fieldtype: "asset",
          filename: null,
          focus: null,
          id: null,
          is_external_url: false,
          meta_data: {},
          name: "",
          title: null
        }
      },
      {
        componentName: "QuickLinks",
        title: "QuickLinks",
        description:
          "Promotions carousel. Take advantage of our best deals and enjoy ",
        previewImage: undefined
      },
      {
        componentName: "TalentPicks",
        title: "Talent Picks",
        description:
          "It's not every day that TV Talents to give you some free tips!! Take advantage of it!",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/421x352/2774e6d638/talentpicks.png",
          focus: "",
          id: 20107577,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks",
        description: "Watch and Learn great tips and insights with experts",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/415x352/108258af6f/tips-picks.png",
          focus: "",
          id: 20107576,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races",
        description: "FD recommended races so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/843x422/e2159256b0/topraces.png",
          focus: "",
          id: 20107572,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopTracks",
        title: "Top Tracks",
        description:
          "FD recommended Tracks so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/716x427/f357deb93d/toptracks.png",
          focus: "",
          id: 20107574,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    main: [
      {
        componentName: "TopPools",
        title: "Top Pools",
        description: "Best Races! Bets Pools. List of highest pools of the day",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/364x386/b834b23256/toppools.png",
          focus: "",
          id: 20107570,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TalentPicks",
        title: "Talent Picks",
        description:
          "It's not every day that TV Talents to give you some free tips!! Take advantage of it!",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/421x352/2774e6d638/talentpicks.png",
          focus: "",
          id: 20107577,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "FeaturedSection",
        title: "Tutorials",
        description: "Learn the basic and advanced betting techniques",
        previewImage: undefined
      },
      {
        componentName: "PreviousWinners",
        title: "Previous Winners",
        description:
          "List of your horses that have won in any of your previous bets",
        previewImage: {
          alt: null,
          copyright: null,
          fieldtype: "asset",
          filename: null,
          focus: null,
          id: null,
          is_external_url: false,
          meta_data: {},
          name: "",
          title: null
        }
      },
      {
        componentName: "QuickLinks",
        title: "QuickLinks",
        description:
          "Promotions carousel. Take advantage of our best deals and enjoy ",
        previewImage: undefined
      },
      {
        componentName: "TipsAndPicks",
        title: "Tips & Picks",
        description: "Watch and Learn great tips and insights with experts",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/415x352/108258af6f/tips-picks.png",
          focus: "",
          id: 20107576,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopRaces",
        title: "Today’s Popular Races",
        description: "FD recommended races so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/843x422/e2159256b0/topraces.png",
          focus: "",
          id: 20107572,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      },
      {
        componentName: "TopTracks",
        title: "Top Tracks",
        description:
          "FD recommended Tracks so you can enjoy a great experience",
        previewImage: {
          alt: "",
          copyright: "",
          fieldtype: "asset",
          filename:
            "https://a.storyblok.com/f/74224/716x427/f357deb93d/toptracks.png",
          focus: "",
          id: 20107574,
          is_external_url: false,
          meta_data: {},
          name: "",
          source: "",
          title: ""
        }
      }
    ],
    bottom: [
      {
        componentName: "SEOFooter",
        title: "Horse Racing Betting",
        description: "",
        previewImage: undefined,
        text: '<p>\n    <span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span><span style="font-family: Arial;">﻿</span>Welcome to <a href="/">FanDuel Racing</a>! We offer an unparalleled experience on a trustworthy platform. Our interface is easy to use. Round-the-clock races put you in the heart of the action.\n</p>\n<p>\n    Get access to:\n    </p><ul>  \n        <li>Major events</li>\n        <li>Easy deposits</li>\n        <li><a href="/promos">Exclusive promos</a></li>\n        <li>Swift payouts</li>\n    </ul>\n<p></p>\n<p>\n    Knowledge is everything! Explore:\n    </p><ul>\n        <li><a href="https://support.fanduelracing.com/s/" target="_blank">Our support site</a> for any questions</li>\n    </ul>\n<p></p>\n<p>\n    Stay engaged with:\n    </p><ul>\n        <li><a href="https://www.fanduel.com/watch" target="_blank">Live FanDuel TV coverage</a> of 300+ global racetracks</li>\n        <li><a href="/handicapping/talent-picks">Picks and previews</a> from your favorite FanDuel TV talent experts</li>\n        <li><a href="https://www.fanduel.com/research/horse-racing" target="_blank">Exclusive horse racing news</a></li>\n    </ul>\n<p></p>\n<p>\n    Get ready to bet on the Triple Crown: <a href="https://www.fanduel.com/kentucky-derby-betting" target="_blank">Kentucky Derby</a>, <a href="https://www.fanduel.com/preakness-stakes-betting" target="_blank">Preakness Stakes</a>, \n<a href="https://www.fanduel.com/belmont-stakes-betting" target="_blank">Belmont Stakes</a>, \n<a href="https://www.fanduel.com/breeders-cup-betting" target="_blank">Breeders Cup</a>.\n</p>\n<p>\n    Want to play FanDuel Racing alone? Or through <a href="https://sportsbook.fanduel.com/" target="_blank">FanDuel Sportsbook</a>?  No problem. In both apps, we blend tradition with cutting-edge technology. You’re ready for the races!\n</p>'
      }
    ]
  }
};
